import { capitalize } from 'lodash';
import { useCallback } from 'react';

import { type AvailablePlanName } from '@air/api/types';
import { type SubscriptionPlan } from '@air/types';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { trackGTMEvent } from '../utils/trackGTMEvent';

export type TrackCompletedCheckoutParams = {
  planId: AvailablePlanName;
  totalPrice: number;
  new_plan: SubscriptionPlan;
  plan: SubscriptionPlan;
  coupon?: string;
};

export const useTrackCompletedCheckout = () => {
  const { track } = useAnalyticsUtilities();

  const trackCompletedCheckout = useCallback(
    ({ planId, totalPrice, new_plan, plan, coupon }: TrackCompletedCheckoutParams) => {
      track(
        `Completed checkout`,
        {
          new_plan,
          plan,
          ...(coupon ? { coupon } : {}),
        },
        { integrations: { Intercom: true } },
      );
      trackGTMEvent({
        event: `${capitalize(planId)} Account Sign Up`,
        eventProps: { category: 'self serve', label: planId, value: totalPrice / 100 },
      });
    },
    [track],
  );

  return { trackCompletedCheckout };
};
